import SectionTitle from "../../../components/section-title";
import PricingItem from "../../../components/pricing";
import HomeData from "../../../data/home.json";
import PropTypes from "prop-types";

const PricingContainer = ({ pricingClassOption }) => {
    return (
        <div className="pricing-area pricing-default-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <SectionTitle classOption="text-center" subTitle="핵심 진료 영역" title="자주 찾는 <span>진료 분야</span>" />
                    </div>
                </div>
                <div className={`row row-gutter-0 pricing-items-style1 ${pricingClassOption}`} data-aos="fade-up" data-aos-duration="1100">
                    {HomeData[7].pricing &&
                        HomeData[7].pricing.map((single, key) => {
                            return (
                                <div key={key} className="col-sm-6 col-md-6 col-lg-3">
                                    <PricingItem key={key} data={single} index={key} />
                                </div>
                            );
                        })}
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <p className="pricing-note">
                            진료비는 환자의 상태와 치료 범위에 따라 달라지며, 진찰 후 자세히 안내해 드립니다.
                            자세한 비용은 내원 또는 전화(031-402-7500)로 문의해 주세요.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

PricingContainer.propTypes = {
    pricingClassOption: PropTypes.string,
};
PricingContainer.defaultProps = {
    pricingClassOption: "row row-gutter-0 pricing-items-style1",
};

export default PricingContainer;
